import React, { Component } from 'react';

class Channels extends Component {

    state = {
        headers: [
            { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}name ...', required: false } },

            // { key: 'type', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'Template Message', value: 'templateMessage' }], label: 'action', placeholder: 'Choose...', required: true } },
            // {
            //     type: 'SubformInput',
            //     key: 'templateMessage',
            //     information: {
            //         headers: [
            //             { key: 'description', type: 'TextAreaInput', col: '4', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },
            //         ],

            //         placeholder: '{{lang}}placeholders.insertInformation',
            //         required: false
            //     },
            //     dependencies: [{
            //         refKey: 'type', targetKey: 'templateMessage',
            //         conditions: [{
            //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'templateMessage' } } }, },
            //             effect: { show: true, changeHeader: [{ key: 'information.required', value: true }] }
            //         }],
            //         else: { show: false, changeHeader: [{ key: 'information.required', value: false }] },
            //         init: true,
            //         // show:true,

            //     }],
            //     showMain: false,
            // },
            // { key: 'name', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },

            // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

            // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
        ]
    }

    render() {
        return (
            <div>

            </div>
        );
    }
}

export default Channels;